import cx from 'classnames'
import React from 'react'
import { NavLink, useParams } from 'react-router-dom'

import { Icons } from 'src/common/components'
import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'

import { useRoutePermissions } from '../../hooks/useRoutePermissions.hook'
import { DefaultMenuConfig } from '../../types/routing.types'
import { getFilteredMenuItems } from '../../utils/menu.utils'
import styles from './menu.module.scss'

interface MenuItemProps extends DefaultMenuConfig {}

const MenuItem: React.FC<MenuItemProps> = ({ path, title, icon }) => {
  const { organizationName } = useParams()

  const IconComponent =
    icon && (Object.entries(Icons)?.find(([key]) => key === icon)?.[1] ?? null)

  return (
    <NavLink
      data-testid={
        path === '/notifications'
          ? 'notification-settings-navigation-link'
          : undefined
      }
      className={({ isActive }) =>
        cx(styles.menuItem, isActive && styles.active)
      }
      to={`/${organizationName}${path}`}
    >
      {IconComponent ? <IconComponent /> : null}
      <div className={styles.title}>{title}</div>
    </NavLink>
  )
}

interface MenuProps {
  menuItems?: DefaultMenuConfig[]
}

const Menu: React.FC<MenuProps> = ({ menuItems: propMenuItems }) => {
  const { userPolicies } = useRoutePermissions()

  const menuItems =
    propMenuItems || (getFilteredMenuItems(userPolicies) as DefaultMenuConfig[])

  return (
    <div className={styles.wrapper}>
      {menuItems.map((menuItem) => (
        <MenuItem key={menuItem.id} {...menuItem} />
      ))}
    </div>
  )
}

export default withErrorBoundaryAndPolicyCheck(Menu, 'is_enable_menu', true)
